export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20workspace%20desk%20with%20open%20laptop%20showing%20colorful%20product%20catalog%20spreadsheet%20with%20thumbnail%20images%20organized%20in%20neat%20rows%20and%20columns%2C%20warm%20cream%20and%20beige%20tones%2C%20soft%20natural%20light%20from%20left%20window%2C%20organized%20desk%20with%20notebook%20and%20coffee%20cup%2C%20modern%20Scandinavian%20office%20aesthetic%2C%20light%20wood%20desk%20texture%2C%20small%20potted%20plant%2C%20editorial%20photography%20style%20with%20soft%20warm%20lighting%2C%20serene%20productive%20atmosphere&width=1600&height=900&seq=hero-sugargoo-v3&orientation=landscape"
          alt="Sugargoo Spreadsheet workspace with organized product data"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/10 to-black/25"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/90 backdrop-blur-sm border border-background-200/50 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            <span className="text-xs font-medium text-foreground-700">Updated Weekly · 1000+ Product Finds</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white leading-tight mb-4">
            Sugargoo Spreadsheet
            <br />
            <span className="text-primary-300">The Ultimate Product Finding Database</span>
          </h1>

          <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            Find thousands of organized Sugargoo product spreadsheets including sneakers, clothing, accessories, QC photos, shipping guides and exclusive buying resources — all in one place.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="/article/sugargoo-spreadsheet-ultimate-guide"
              className="w-full sm:w-auto px-6 py-3 rounded-full bg-primary-500 text-white hover:bg-primary-600 text-sm md:text-base font-semibold transition-all cursor-pointer whitespace-nowrap"
            >
              Explore Sugargoo Spreadsheet
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-6 py-3 rounded-full bg-white/15 backdrop-blur-sm text-white hover:bg-white/25 border border-white/20 text-sm md:text-base font-medium transition-all cursor-pointer whitespace-nowrap"
            >
              Visit Main Website
              <i className="ri-external-link-line ml-2"></i>
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 mt-10">
            {[
              { icon: "ri-checkbox-circle-line", text: "Updated Weekly" },
              { icon: "ri-database-2-line", text: "1000+ Product Finds" },
              { icon: "ri-user-heart-line", text: "Beginner Friendly" },
              { icon: "ri-gift-line", text: "Free Resources" },
            ].map((badge) => (
              <div
                key={badge.text}
                className="flex items-center gap-1.5 text-white/75 text-xs md:text-sm"
              >
                <i className={`${badge.icon} text-primary-300`}></i>
                <span>{badge.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}